import React from "react";
import { FaStar, FaHome, FaHeart } from "react-icons/fa";
import { useLanguage } from "../../context/LanguageContext";

const FamousResidentsStats = () => {
  const { t } = useLanguage();

  const statsData = [
    {
      icon: FaStar,
      value: "100+",
      description: t("famousResidentsStats.knownPersons"),
      color: "turquoise"
    },
    {
      icon: FaHome,
      value: "50+",
      description: t("famousResidentsStats.permanentResidents"),
      color: "yellow"
    },
    {
      icon: FaHeart,
      value: "200+",
      description: t("famousResidentsStats.nationalities"),
      color: "turquoise"
    },
    {
      icon: FaStar,
      value: "84%",
      description: t("famousResidentsStats.expatRatio"),
      color: "yellow"
    }
  ];

  const getColorClass = (color) => {
    return color === "turquoise" ? "text-info" : "text-warning";
  };

  return (
    <div className="famous-residents-stats py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="d-flex flex-wrap justify-content-center gap-4">
              {statsData.map((stat, index) => (
                <div
                  key={index}
                  className="famous-resident-stat-card text-center p-4 shadow"
                  style={{
                    backgroundColor: "rgba(33, 37, 41, 0.4)",
                    borderRadius: "25px",
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    minWidth: "200px",
                    flex: "1",
                    maxWidth: "250px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    minHeight: "180px"
                  }}
                >
                  <div 
                    className="stat-icon mb-3"
                    style={{ fontSize: "1.5rem" }}
                  >
                    <stat.icon className={getColorClass(stat.color)} />
                  </div>
                  
                  <div 
                    className={`stat-value mb-2 ${getColorClass(stat.color)}`}
                    style={{ 
                      fontSize: "1.5rem", 
                      fontWeight: "bold",
                      lineHeight: "1.2"
                    }}
                  >
                    {stat.value}
                  </div>
                  
                  <div 
                    className="stat-description text-white"
                    style={{ 
                      fontSize: "0.9rem", 
                      lineHeight: "1.4",
                      textAlign: "center"
                    }}
                  >
                    {stat.description}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FamousResidentsStats;
